import type { WidenMediaElement } from '@libs/widen-utils';
import { mediaElementTypeSortOrder } from '@libs/widen-utils';

export function sortByParam<T>(callback: (item: T) => string | number, desc = false, nullsLast = false) {
  return (a: T, b: T) => {
    const compareValueA = callback(a);
    const compareValueB = callback(b);
    if (nullsLast) {
      if (compareValueA === undefined) {
        // if A is undefined move it to end
        return 1;
      }
      if (compareValueB === undefined) {
        // if B is undefined move it to end
        return -1;
      }
    }
    if (compareValueA > compareValueB) {
      return desc ? -1 : 1;
    }

    if (compareValueA < compareValueB) {
      return desc ? 1 : -1;
    }

    return 0;
  };
}

export const sortByMediaElementTypeSortOrder = (media1: WidenMediaElement, media2: WidenMediaElement) =>
  mediaElementTypeSortOrder.indexOf(media1.type) - mediaElementTypeSortOrder.indexOf(media2.type);

/**
 * sort array based on another array
 */
export function sortByAnotherArray<T>(
  a: T,
  b: T,
  items: T[],
  options: { moveMissingItems?: 'end' | 'start' } = { moveMissingItems: 'start' }
) {
  const { moveMissingItems } = options || {};
  const indexA = items.indexOf(a);
  const indexB = items.indexOf(b);

  if ((indexA !== -1 && indexB !== -1) || moveMissingItems === 'start') {
    return indexA - indexB;
  }

  // If one of the keys is not found in items, move it to the end
  if (indexA === -1 && indexB === -1) {
    // both are not found, maintain their relative order
    return 0;
  }

  // move a to the end
  if (indexA === -1) {
    return 1;
  }

  // move b to the end
  return -1;
}
